import React from "react";

import styled from "styled-components";
import { Box, FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";
import Image from "@/components/Atoms/Image";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Divider from "@/components/Atoms/Divider";
import theme from "@/foundation/Theme";
import Typography from "@/foundation/Typography/V2";
import { isMobile } from "@/utils";
import { OfferCard, ImageBox, CouponBox, LogoContainer } from "./Style";

function OfferCardView(Props) {
  const {
    bannerImageUrl,
    productDetail,
    partnerName,
    logoUrl,
    productWebPageUrl,
    discountPercentage,
    offerPromoCode,
    redirectPageLink,
    offerValidityDate,
  } = Props?.cardData;
  return (
    <OfferCard>
      <ImageBox src={bannerImageUrl} isMobile={isMobile} />
      <FlexDiv
        mt="24px"
        mb="16px"
        px="24px"
        style={{
          gap: "27px",
        }}
        flexDirection={["column", "column", "row"]}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems={isMobile ? "center" : "flex-start"}
          maxWidth="337px"
        >
          <Typography
            variant="span"
            mb="12px"
            lineHeight="20px"
            fontWeight="600"
          >
            {productDetail}
          </Typography>

          <Button
            onClick={() => {
              window.open(redirectPageLink, "_blank");
              return null;
            }}
            type="button"
            bgColor={theme.colorsV2.shyft.purple_text}
            width="197px"
            height="56px"
            variant="primary1"
          >
            Redeem Now
          </Button>
        </Box>
        <CouponBox
          py="13px"
          flexDirection={isMobile ? "row" : "column"}
          alignItems="center"
          justifyContent="space-around"
        >
          <FlexDiv flexDirection="column" alignItems="center">
            <Typography
              variant="display1"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              color={theme.colorsV2.blueGray.shade_500}
            >
              upto
            </Typography>
            <Typography
              variant="display1"
              fontSize={["16px", "24px", "24px"]}
              lineHeight={["21px", "21px", "32px"]}
              fontWeight="700"
              color={theme.colorsV2.shyft.purple_text}
            >
              {discountPercentage}% off
              <Typography
                ml="5px"
                variant="span"
                fontSize="14px"
                lineHeight="20px"
                fontWeight="700"
                color={theme.colorsV2.blueGray.shade_500}
              >
                extra
              </Typography>
            </Typography>
          </FlexDiv>
          <FlexDiv flexDirection="column" alignItems="center">
            <FlexDiv
              padding="8px 16px 8px 16px"
              bg="#FEF0C7"
              borderRadius="70px"
              // my="4px"
            >
              <Typography
                variant="span"
                fontSize="14px"
                lineHeight="20px"
                fontWeight="600"
                color={theme.colorsV2.gray.shade_400}
                mr="8px"
              >
                CODE:
              </Typography>
              <Typography
                variant="span"
                fontSize={["12px", "12px", "14px"]}
                lineHeight="20px"
                fontWeight="600"
                color={theme.colorsV2.blueGray.shade_500}
              >
                {offerPromoCode}
              </Typography>
            </FlexDiv>
            <Typography
              variant="display1"
              fontSize={["10px", "10px", "13px"]}
              lineHeight="20px"
              fontWeight="600"
              color={theme.colorsV2.gray.shade_400}
            >
              Valid till {offerValidityDate}
            </Typography>
          </FlexDiv>
        </CouponBox>
      </FlexDiv>
      <Divider />
      <FlexDiv
        mt="16px"
        px="24px"
        flexDirection={isMobile ? "column" : "row"}
        alignItems={isMobile ? "flex-start" : "center"}
        justifyContent="space-between"
      >
        <FlexDiv
          alignItems="center"
          justifyContent="center"
          style={{
            gap: "16px",
          }}
        >
          <LogoContainer
            width="48px"
            height="48px"
            alignItems="center"
            justifyContent="center"
          >
            <img
              src={logoUrl}
              alt=""
              height="100%"
              width="100%"
              style={{
                objectFit: "contain",
              }}
            />
          </LogoContainer>
          <Typography
            variant="heading6"
            fontSize="18px"
            lineHeight="24px"
            color={theme.colorsV2.blueGray.shade_700}
          >
            {partnerName}
          </Typography>
        </FlexDiv>
        <FlexDiv
          alignItems="center"
          justifyContent="center"
          style={{
            gap: "4px",
          }}
          ml={isMobile ? "53px" : "0px"}
          mt={isMobile ? "-10px" : "0px"}
        >
          <StyledSvgSprite icon="icon-link" height="20px" width="20px" />
          <a href={redirectPageLink} target="_blank">
            <Typography
              variant="link2"
              fontSize="14px"
              lineHeight="24px"
              link2Color="#0000EE"
              fontFamily="var(--man-500)"
              letterSpacing="1.4px"
              ml={isMobile ? "10px" : "0px"}
            >
              {productWebPageUrl}
            </Typography>
          </a>
        </FlexDiv>
      </FlexDiv>
    </OfferCard>
  );
}

export default OfferCardView;
